import { useState } from 'react';
import { Alert, AlertTitle, AlertDescription, Button } from '@chakra-ui/react';
import { TravelStatusDescription, statusColorScheme } from './helpers';
import { TravelStatusModal } from './modal';
import { ITravelStatus } from '../../../../../types';

export interface IProps {
  saveTravelStatus: (data: ITravelStatus) => void;
  travelStatus: ITravelStatus;
}

export const TravelStatus = (props: IProps) => {
  const {
    travelStatus: { status },
    saveTravelStatus
  } = props;

  const modalStatus = new URLSearchParams(window.location.search).get('isModalOpen') || false;
  window.history.replaceState(null, document.title, window.location.pathname);
  const [isModalOpen, setIsModalOpen] = useState(modalStatus);

  return (
    <Alert
      as="div"
      role="generic"
      data-selector="enrolment-section-travel-status-block"
      variant="status-block"
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      colorScheme={statusColorScheme({ travelStatus: status! })}
    >
      <AlertTitle>Travel Status</AlertTitle>

      <AlertDescription>
        <TravelStatusDescription travelStatus={props.travelStatus} />
      </AlertDescription>

      <Button size="lg" variant="solid" onClick={() => setIsModalOpen(true)} mt={4}>
        Update travel status
      </Button>

      {isModalOpen && (
        <TravelStatusModal
          saveTravelStatus={saveTravelStatus}
          travelStatus={props.travelStatus}
          onModalClose={() => setIsModalOpen(false)}
        />
      )}
    </Alert>
  );
};
